import { useLang } from "../../context/LanguageContext";

export const Ecosystem = () => {
  const { t } = useLang();
  return (
    <section id="ecosystem" data-testid="ecosystem-section" className="py-24 lg:py-32 bg-[#F8F9FA] border-b border-[#0B1F3A]/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-12 gap-6 mb-14">
          <div className="col-span-12 lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-8 h-px bg-[#D4AF37]" />
              <span className="overline">{t.ecosystem.eyebrow}</span>
            </div>
            <h2 className="font-display text-3xl lg:text-4xl font-light text-[#0B1F3A] leading-tight">
              {t.ecosystem.title}
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="text-[#0B1F3A]/70 text-base lg:text-lg leading-relaxed">{t.ecosystem.sub}</p>
          </div>
        </div>

        <div className="border border-[#0B1F3A]/15 bg-white p-6 lg:p-10">
          <EcosystemMap nodes={t.ecosystem.nodes} />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 mt-8 border-t border-l border-[#0B1F3A]/15">
          {t.ecosystem.nodes.map((n, i) => (
            <div key={n.name} className="border-r border-b border-[#0B1F3A]/15 p-6 bg-white">
              <div className="text-[10px] tracking-widest text-[#0B1F3A]/40 font-mono">NODE · {String(i + 1).padStart(2, "0")}</div>
              <div className="mt-3 font-display text-[15px] font-semibold text-[#0B1F3A]">{n.name}</div>
              <div className="mt-2 text-xs text-[#0B1F3A]/70 leading-relaxed">{n.role}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const EcosystemMap = ({ nodes }) => {
  // central node + 3 surrounding
  const center = nodes[0];
  const peripheral = nodes.slice(1);
  return (
    <svg viewBox="0 0 800 360" className="w-full h-auto" data-testid="ecosystem-diagram">
      <defs>
        <pattern id="ecogrid" width="40" height="40" patternUnits="userSpaceOnUse">
          <path d="M 40 0 L 0 0 0 40" fill="none" stroke="rgba(11,31,58,0.05)" strokeWidth="1" />
        </pattern>
      </defs>
      <rect width="800" height="360" fill="url(#ecogrid)" />

      {/* lines */}
      <g stroke="#0B1F3A" strokeWidth="1">
        <line x1="400" y1="180" x2="180" y2="80" />
        <line x1="400" y1="180" x2="620" y2="80" />
        <line x1="400" y1="180" x2="400" y2="310" />
      </g>
      <g stroke="#2563EB" strokeWidth="1.5" fill="none" className="svg-flow">
        <line x1="400" y1="180" x2="180" y2="80" />
        <line x1="400" y1="180" x2="620" y2="80" />
        <line x1="400" y1="180" x2="400" y2="310" />
      </g>

      {/* center */}
      <g>
        <rect x="310" y="148" width="180" height="64" fill="#0B1F3A" />
        <rect x="310" y="148" width="180" height="64" fill="none" stroke="#D4AF37" strokeWidth="1.5" />
        <text x="400" y="178" textAnchor="middle" fontSize="13" fontFamily="IBM Plex Sans" fontWeight="600" fill="#FFFFFF" letterSpacing="0.5">
          {center.name}
        </text>
        <text x="400" y="196" textAnchor="middle" fontSize="9" fontFamily="Inter" fill="#D4AF37" letterSpacing="1.5">
          {center.role.toUpperCase()}
        </text>
      </g>

      {/* peripheral */}
      {[
        { x: 100, y: 50, w: 160 },
        { x: 540, y: 50, w: 160 },
        { x: 320, y: 280, w: 160 },
      ].map((p, i) => (
        <g key={i}>
          <rect x={p.x} y={p.y} width={p.w} height="60" fill="#FFFFFF" stroke="#0B1F3A" strokeWidth="1" />
          <text x={p.x + p.w / 2} y={p.y + 26} textAnchor="middle" fontSize="11" fontFamily="IBM Plex Sans" fontWeight="600" fill="#0B1F3A">
            {peripheral[i].name}
          </text>
          <text x={p.x + p.w / 2} y={p.y + 44} textAnchor="middle" fontSize="8.5" fontFamily="Inter" fill="#0B1F3A" opacity="0.6" letterSpacing="0.8">
            {peripheral[i].role}
          </text>
        </g>
      ))}
    </svg>
  );
};
